/*
 * @Description: 页面头
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-11 14:37:10
 * @LastEditTime: 2019-08-26 11:57:17
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Header.css';
import cx from 'classnames'
import Link from '../Link';
import Navigation from '../Navigation';
// @ts-ignore
import Search from '../Search';
import history from '../../history';
import SearchError from '../SearchError'
import { isMobile } from '../../utils';
import Logo from '../Logo';
import { getBrandName } from '../../controller';


class Header extends React.Component {
  constructor(props) {
    super(props)
    
    this.state = {
      loading: true,
      error: null,
      data: null,
      value: '',
      tentative:null,
      selectIndex: 0,
      items: [],
      displayName: s.hide,
      y: 0,
      navShow: true,
      seaShow: false,
      isfixed: false,
      isFocus: false,
      isSelected:false,
      id:null,
      isLoginUser:false,
      isShowSea:false,
      mouseLeave:true
    }

    this.hideSub = this.hideSub.bind(this)
    this.handleScroll = this.handleScroll.bind(this)
    this.seaComplete = this.seaComplete.bind(this)
    this.showSub = this.showSub.bind(this)
    this.keyDown = this.keyDown.bind(this)
    this.isFocus = this.isFocus.bind(this)
    this.isFocusFalse = this.isFocusFalse.bind(this)
    this.closeSea=this.closeSea.bind(this)
    this.mouseSlect=this.mouseSlect.bind(this)
    this.mouseOnClick=this.mouseOnClick.bind(this)
    this.mouseLeave=this.mouseLeave.bind(this)
    this.mouseEnter=this.mouseEnter.bind(this)
    this.buttonClick=this.buttonClick.bind(this)
  }
  
  componentDidMount() {
    if (isMobile()) {
      alert('感谢关注『数字品牌榜』，推荐在PC端访问，获得更好的使用体验和服务')
    }
    
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
  mouseEnter=()=>{
    this.setState({mouseLeave:false})
  }
  mouseLeave=()=>{
    this.setState({mouseLeave:true})
  }

  mouseSlect=(index)=>{
    this.setState({selectIndex:index})
  }

  mouseOnClick=()=>{
    const{items,num,id,selectIndex}=this.state

    if(items.length==0){
      this.setState({isShowSea:true})
    }else {
      // localStorage.setItem('isSea','true')
      // localStorage.setItem('seaName',`${items[selectIndex].name}`)

      let enUrl=encodeURIComponent(items[selectIndex].name) 
      // console.log(items[selectIndex].name,encodeURIComponent(items[selectIndex].name),enUrl )
      
      history.push(`/dashboard?brandName=${enUrl}`)
      this.setState({value:'',items:[],isFocus:false})
    }

  }
  buttonClick=()=>{
    const {items,num,selectIndex}=this.state
    // localStorage.setItem('isSea','true')
    // localStorage.setItem('seaName',`${items[selectIndex].name}`)
    let enUrl=encodeURIComponent(items[selectIndex].name) 
    // console.log(items[selectIndex].name,encodeURIComponent(items[selectIndex].name),enUrl )
    
    history.push(`/dashboard?brandName=${enUrl}`)
    // history.push(`/dashboard?brandName=${localStorage.getItem('seaName')}`)
    this.setState({value:'',items:[],isFocus:false})

  }


  seaComplete(e) {
    // console.log(this.state.value)
    this.setState({ value: e.target.value })
    if (e.target.value != '') {
      // console.log(encodeURIComponent(decodeURIComponent(e.target.value)))
      // const url = `/digitalAssets/s?q=${encodeURIComponent(decodeURIComponent(e.target.value))}`;
      
      getBrandName({q: e.target.value})
        // fetch(url).then(response => response.json())
        .then(data => {
          let _data = typeof data === 'string' ? JSON.parse(data) : data
          
          // console.log(data,'搜索数据···················')
          this.setState({
              loading: false,
              data: _data,
              items: _data.items || []
          })
        })
        .catch(e => console.log("Oops, error", e))
    }
  }

  isFocus() {
    // console.log('获取焦点')
    this.setState({
      isFocus: true
    })
  }
  isFocusFalse() {
    // console.log('失去焦点')
    if(this.state.mouseLeave){

      this.setState({
        isFocus: false,
        value: '',
        items: []
      })
    }
  }
  showSub() {
    this.setState({ displayName: s.subMune, isfixed: true })
  }
  hideSub() {
    this.setState({ displayName: s.hide, isfixed: false })
  }
  
  handleScroll(e) {
    // console.log(document.documentElement.scrollTop,window.scrollY,window.pageYOffset)
    // let scrollY=scrollY||document.documentElement.scrollTop;
    if(window.pageYOffset){
      if(window.pageYOffset<0){
        this.setState({ seaShow:false,navShow:true})
      }else if (window.pageYOffset < this.state.y && this.state.isfixed) {
        this.setState({ seaShow: false, navShow: true })

      } else if (window.pageYOffset > this.state.y && !this.state.isfixed) {
        // console.log('搜索')
        this.setState({ y: window.pageYOffset, seaShow: true, navShow: false })
      } else if (window.pageYOffset < this.state.y&& !this.state.isFocus) {
        // console.log('导航')
        this.setState({ y: window.pageYOffset, seaShow: false, navShow: true })
      }
    }
  }
  keyDown(e) {

    const { selectIndex, items, value,isSelected,id,tentative } = this.state
    const num = selectIndex % items.length




    // console.log(value,items,selectIndex,'aaaaaaaaaaaaaaaaaaaaaaaa',e.key)
    switch (true){

      case(e.key=='Enter'&&value!=''&&items.length!=0):
        // console.log(items.length,'补全个数')
        // console.log('精确搜索'+items[num],items[num],items[num].name)
        localStorage.setItem('sea',`${items[num].id}`)
        localStorage.setItem('isSea','true')
        localStorage.setItem('seaName',`${items[num].name}`)
        let enUrl=encodeURIComponent(items[num].name) 
        
        history.push(`/dashboard?brandName=${enUrl}`)
        // history.push(`/dashboard?brandId=${localStorage.getItem('sea')}`)
        // history.push(`/dashboard?brandName=${localStorage.getItem('seaName')}`)
    
        this.setState({value:'',items:[],isFocus:false})

        break
      // case(selectIndex==0&&e.key=='Enter'):
      //   this.setState({value:items[num]['name']})
      //   break
      // case(selectIndex==0||null):
      //   this.setState({selectIndex:6})
      //   break

      case(e.key=='Enter'):
        // alert('no')
        this.setState({
          isShowSea:true
        })
        break
      case(e.key=='ArrowUp'&&items.length!=0):

        let cc=selectIndex<1? items.length-1:selectIndex-1
        this.setState({selectIndex:cc})
        // this.setState({selectIndex:selectIndex-1})
        break
      case(e.key=='ArrowDown'&&items.length!=0):
        let bb=selectIndex<1?selectIndex+1:selectIndex+1
        this.setState({selectIndex:bb})
        // this.setState({selectIndex:selectIndex+1})
        break
      // case(e.key=='Enter'&&items.length>0):
      //   console.log('提取关键词')
      //   this.setState({value:items[num]['name']})
      //   break
      case(e.key=='Backspace'&&value.length==1):
        this.setState({items:[]})

    }

  }

  getAccurateSearch(idd) {

    // 得到id  进行跳转
    history.push(`/mindshare?id=${idd}`);
    this.setState({value:'',items:[ ],isSelected:false,id:null})
  }

 
  closeSea=()=>{
    this.setState({isShowSea:false,isFocus:false,value:''})
  }

  render() {
    // console.log(this.state.selectIndex)
    // console.log(this.state.isLoginUser)
    const { selectIndex, items } = this.state
    return (
      <div className={s.root}>
        <SearchError show={this.state.isShowSea} close={this.closeSea} />
        <div className={s.container}>
          <div className={s.nav}>
            <div className={s.logo}>
              <Logo />
            </div>

            <Search
              isFocus={this.isFocus}
              isFocusFalse={this.isFocusFalse}
              keyDown={this.keyDown}
              value={this.state.value}
              seaShow={this.state.seaShow}
              sea={this.seaComplete} 
              isLoginUser={this.state.isLoginUser}
              handleClick={this.mouseOnClick}
              onMouseLeave={this.mouseLeave}
              onMouseEnter={this.mouseEnter}
              user={this.props.user}
              // fixedLeft={true}
              doChangeLoginState={this.props.doChangeLoginState} />

            <Navigation
              showSub={this.showSub}
              hideSub={this.hideSub}
              navShow={this.state.navShow} />
          </div>
        </div>
        <div className={s.posi}>
          <ul
            className={this.state.displayName}
            onMouseLeave={this.hideSub}
            onMouseEnter={this.showSub} >
            <li className={s.subItem} onClick={this.hideSub}>

              <Link to='/top100'>总 榜</Link>
            </li>
            <li className={s.subItem} onClick={this.hideSub}>
              <Link to='/industry'>行业榜</Link>
            </li>
            <li className={s.subItem} onClick={this.hideSub}>
              <Link to='/platform'>平台榜</Link>
            </li>
            <li className={s.subItem} onClick={this.hideSub}>
              <Link to='/geo'>地理榜</Link>
            </li>
          </ul>
          <ul className={s.seaItems} 
            onMouseLeave={this.mouseLeave}
            onMouseEnter={this.mouseEnter}
           >
            {items
              .map((item, index) => (
                <li key={index} className={selectIndex % items.length == index ? cx(s.seaItem, s.ac) : s.seaItem}
                    onMouseEnter={()=>this.mouseSlect(index)}
                    onClick={this.mouseOnClick}
                >
                  <i><img src={`/digitalAssets/resources/img/LOGO/${item.id}.png`} /></i>
                  {item.name}
                </li>

              ))}
          </ul>

        </div>

      </div>
    )
  }

}

export default withStyles(s)(Header);



// WEBPACK FOOTER //
// src/components/Header/Header.js